export const styles = {
  rotatingPicture: {
    width: '104px',
    position: 'absolute',
    zIndex: 1,
    top: '32px',
    animation: 'spin 8s linear infinite',
    '@keyframes spin': {
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
    '@media screen and (max-width: 1000px)': {
      top: '20px',
      left: '5px',
    },
  },

  image: {
    '@media screen and (min-width: 900)': {
      width: '314px',
    },

    '@media screen and (min-width: 1270px)': {
      width: '604px',
    },
  },
};
